/**
 * Spanish & French translations for top 20 newcomer-friendly credit card rewards.
 * Keyed by card ID from credit_card_data.json.
 * Expired promotional details removed; core value proposition kept.
 */
const CARD_TRANSLATIONS = {
  '1352': {
    es: 'Ganas crédito Cash Back por un porcentaje de cada compra elegible que hagas.',
    fr: 'Obtenez un crédit en remises en argent pour un pourcentage de chaque achat admissible.',
  },
  '1353': {
    es: 'Acumula puntos TD Rewards canjeables en compras elegibles de Amazon.ca. Sin cuota anual.',
    fr: 'Accumulez des points Récompenses TD échangeables sur Amazon.ca. Sans frais annuels.',
  },
  '1382': {
    es: 'Tasa de interés baja en compras y adelantos de efectivo. Ideal si prefieres pagar menos intereses.',
    fr: 'Taux d\'intérêt bas sur les achats et avances de fonds. Idéale si vous préférez payer moins d\'intérêts.',
  },
  '1360': {
    es: 'Hasta 5% de cash back en los primeros 3 meses. Sin cuota anual.',
    fr: 'Jusqu\'à 5 % de remises en argent les 3 premiers mois. Sans frais annuels.',
  },
  '1359': {
    es: '800 millas AIR MILES de bienvenida (equivalen a $80 en compras con AIR MILES Cash).',
    fr: '800 milles AIR MILES de bienvenue (équivalent à 80 $ en achats avec AIR MILES Cash).',
  },
  '1361': {
    es: '20,000 puntos de bienvenida. Acumula hasta 5,000 puntos extra cada año.',
    fr: '20 000 points de bienvenue. Accumulez jusqu\'à 5 000 points supplémentaires chaque année.',
  },
  '1362': {
    es: 'Acumula puntos BMO Rewards en cada compra para canjear en viajes, productos y más.',
    fr: 'Accumulez des points Récompenses BMO sur chaque achat, échangeables en voyages et plus.',
  },
  '1372': {
    es: 'Cash back en todas tus compras.',
    fr: 'Remises en argent sur tous vos achats.',
  },
  '1373': {
    es: '3,500 puntos Avion de bienvenida (equivalen a $25 en tarjetas de regalo).',
    fr: '3 500 points Avion de bienvenue (équivalent à 25 $ en cartes-cadeaux).',
  },
  '1371': {
    es: '3,000 puntos Moi de bienvenida con la tarjeta moi RBC Visa.',
    fr: '3 000 points Moi de bienvenue avec la carte moi RBC Visa.',
  },
  '1363': {
    es: 'Hasta $200 en valor durante tu primer año. Acumula puntos Aeroplan en cada compra.',
    fr: 'Jusqu\'à 200 $ en valeur la première année. Accumulez des points Aeroplan sur chaque achat.',
  },
  '1364': {
    es: 'Hasta 2,500 puntos Aventura sin cuota anual.',
    fr: 'Jusqu\'à 2 500 points Aventura sans frais annuels.',
  },
  '1366': {
    es: 'Hasta 10¢ de descuento por litro en gasolineras participantes con Journie Rewards.',
    fr: 'Jusqu\'à 10 ¢ de rabais par litre aux stations-service participantes avec Journie Rewards.',
  },
  '1376': {
    es: 'Hasta 3% de cash back en compras elegibles en cualquier lugar que acepte Mastercard.',
    fr: 'Jusqu\'à 3 % de remises en argent sur les achats admissibles partout où Mastercard est acceptée.',
  },
  '1356': {
    es: 'Hasta 1% de cash back: 1% en pagos sin contacto, 1% en pagos móviles, 1% en pagos preautorizados, 0.5% en otras compras. Se acredita automáticamente al acumular $25.',
    fr: 'Jusqu\'à 1 % de remises : 1 % sur les paiements sans contact, 1 % sur les paiements mobiles, 1 % sur les prélèvements automatiques, 0,5 % sur les autres achats. Crédit automatique à 25 $.',
  },
  '1340': {
    es: 'Hasta 2% de tus compras en Bonusdólares.',
    fr: 'Jusqu\'à 2 % de vos achats en Bonusdollars.',
  },
  '1348': {
    es: '5% de regreso en tus primeros $3,000 en compras elegibles en Amazon.ca, Whole Foods, supermercados y restaurantes.',
    fr: '5 % de remise sur vos premiers 3 000 $ d\'achats admissibles chez Amazon.ca, Whole Foods, épiceries et restaurants.',
  },
  '1399': {
    es: 'Sin recompensas. Tarjeta garantizada ideal para construir historial crediticio en Canadá.',
    fr: 'Pas de récompenses. Carte garantie idéale pour bâtir un historique de crédit au Canada.',
  },
  '1377': {
    es: 'Cash back sin cuota anual.',
    fr: 'Remises en argent sans frais annuels.',
  },
  '1358': {
    es: '2% en gasolina y supermercados en Canadá (hasta $15,000/año en supermercados), 1.25% en todas las demás compras.',
    fr: '2 % sur l\'essence et les épiceries au Canada (jusqu\'à 15 000 $/an en épiceries), 1,25 % sur tous les autres achats.',
  },
  // Tangerine (key referral partner)
  '1344': {
    es: 'Recompensas Money-Back depositadas mensualmente en tu cuenta.',
    fr: 'Remises en argent déposées mensuellement dans votre compte.',
  },
  '1345': {
    es: '2% en categorías Money-Back a tu elección + 0.5% en todo lo demás.',
    fr: '2 % dans les catégories remises de votre choix + 0,5 % sur tout le reste.',
  },
  // Scotiabank (popular with newcomers)
  '1351': {
    es: 'Hasta 7,500 puntos Scene+ de bienvenida en los primeros 3 meses (equivalen a $75 en viajes).',
    fr: 'Jusqu\'à 7 500 points Scene+ de bienvenue les 3 premiers mois (équivalent à 75 $ en voyages).',
  },
  '1375': {
    es: '2 puntos Scene+ por cada $1 en Sobeys, Safeway, Foodland y participantes. 1 punto por cada $1 en otras compras.',
    fr: '2 points Scene+ par dollar chez Sobeys, Safeway, Foodland et participants. 1 point par dollar sur les autres achats.',
  },
};

// Also handle duplicate card IDs (same card appears twice in data)
CARD_TRANSLATIONS['1143'] = CARD_TRANSLATIONS['1359']; // BMO AIR MILES duplicate
CARD_TRANSLATIONS['1144'] = CARD_TRANSLATIONS['1360']; // BMO CashBack duplicate
CARD_TRANSLATIONS['1147'] = CARD_TRANSLATIONS['1363']; // CIBC Aeroplan duplicate

/**
 * Get translated rewards text for a card.
 * Falls back to original English text if no translation exists.
 */
export const getCardRewards = (cardId, rewards, lang = 'es') => {
  if (lang === 'en') return rewards;
  const t = CARD_TRANSLATIONS[cardId];
  if (t && t[lang]) return t[lang];
  return rewards;
};

export default CARD_TRANSLATIONS;
